/**
 * @file [[...taxonomy]].tsx
 *
 * @fileoverview Organizations search page, can be accessed by going to /organizations.
 * The page displays the full organizations search page, and automatically
 * generates the query to solr via the parameters found in the URL.
 */
import JobiqoOrganizationPage, {
  getServerSideProps,
} from '~/jobiqo/pages/organizations';
export default JobiqoOrganizationPage;
export { getServerSideProps };
